import React from 'react';
import { IntlProvider } from 'react-intl';

import {
  type IntlMessageLocale,
  DEFAULT_INTL_MESSAGE_LOCALE,
} from '@/i18n/intl-message-locales';

export type AvailableLocale = IntlMessageLocale;

export const locale = DEFAULT_INTL_MESSAGE_LOCALE;

export const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

type IntlProviderProps = React.ComponentProps<typeof IntlProvider>;
export const defaultRichTextElements: IntlProviderProps['defaultRichTextElements'] =
  {
    b: chunks => <b>{chunks}</b>,
  };

/** Compiled message catalogs (FormatJS `compile` with smartling in → simple out). */
type LocaleTranslations = Record<string, string>;
export type Translations = {
  [locale in AvailableLocale]: LocaleTranslations;
};
